import styled from '@emotion/styled';

export const TotalUserCard = styled.div`
    width: calc(100% - 10px);
    height: calc(100% - 10px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid ${props => props.theme.border};
    border-radius: 10px;
    box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.1);
    padding: 10px;
    margin: 0px 10px 10px 0px;

    .Title {
        font-size: 15px;
        color: ${props => props.theme.text};
    }

    .Value {
        font-size: 20px;
        font-weight: bold;
        color: ${props => props.theme.text};
        p{
            margin: 0px;
        }
    }
`;